import { BigNumber } from 'bignumber.js';
import * as Schema from 'effect/Schema';
import * as SchemaGetter from 'effect/SchemaGetter';
import { Option } from '../Option/index.js';
import { Order } from '../Order/index.js';
export const equivalence = (left, right) => left.eq(right);
export const valueEquivalenceStrict = (left, right) => {
    if (BigNumber.isBigNumber(left) && BigNumber.isBigNumber(right)) {
        return left.eq(right);
    }
    return left === right;
};
export const order = Order.make((left, right) => {
    const result = left.comparedTo(right);
    if (result === null) {
        return 0;
    }
    return result;
});
export const makeUnsafe = (input) => {
    if (BigNumber.isBigNumber(input)) {
        return input;
    }
    return BigNumber(input);
};
export const make = (input) => {
    const bn = BigNumber(input);
    if (bn.isNaN() || !bn.isFinite()) {
        return Option.none();
    }
    return Option.some(bn);
};
export const parse = (input) => {
    const regex = /[^\d.-]/g;
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    const sanitized = input.replace(regex, '');
    if (!sanitized) {
        return Option.none();
    }
    const bn = BigNumber(sanitized);
    if (bn.isNaN() || !bn.isFinite()) {
        return Option.none();
    }
    return Option.some(bn);
};
export const FromString = Schema.String.pipe(Schema.decodeTo(Schema.instanceOf(BigNumber, {
    toEquivalence: () => equivalence,
    identifier: 'BigNumber',
}), {
    decode: SchemaGetter.transform((s) => new BigNumber(s)),
    encode: SchemaGetter.transform((bn) => bn.toString()),
}));
//# sourceMappingURL=BigNumber.js.map